import { render, staticRenderFns } from "./Ocupacao.vue?vue&type=template&id=62603a4c&scoped=true&"
import script from "./Ocupacao.vue?vue&type=script&lang=js&"
export * from "./Ocupacao.vue?vue&type=script&lang=js&"
import style0 from "./Ocupacao.vue?vue&type=style&index=0&id=62603a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62603a4c",
  null
  
)

export default component.exports